/** @jsx jsx */
import { jsx } from 'theme-ui'
import { array, bool, func, string } from 'prop-types'
import Beside from './Beside'
import Series from './Series'
import Generic from './Generic'
import AudienceMatrix from './AudienceMatrix'
import MarketingMatrix from './MarketingMatrix'

const QuestionType = props => {
  const { type, questions } = props
  const components = {
    beside: Beside,
    series: Series,
    'audience-matrix': AudienceMatrix,
    'marketing-matrix': MarketingMatrix,
  }

  const Component = components[type]
  if (Component) return <Component {...props} questions={questions} />

  return questions.map(question => {
    return <Generic question={question} key={question.id} {...props} />
  })
}

QuestionType.propTypes = {
  type: string,
  questions: array,
  questionHasTooManyAnswers: bool,
  setQuestionHasTooManyAnswers: func,
}

export default QuestionType
